
import React from "react";

const OpportunitiesSection = () => {
  const handleClick = () => {
    const section = document.getElementById("career-form-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>
        Ready to Discover Opportunities? Take the First Step
      </h1>
      <p style={styles.description}>
        As we work together to propel some of the world's best-known businesses
        into the future, we help candidates at all levels enhance their skills,
        gain a distinct advantage and supercharge their potential.
      </p>
      <button style={styles.button} onClick={handleClick}>
        Explore global opportunities →
      </button>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#0c859b",
    color: "white",
    textAlign: "center",
    padding: "8px 20px",
    marginTop:'10px',
  },
  heading: {
    fontSize: "26px",
    fontWeight: "600",
    marginBottom: "20px",
    color: "white",
    letterSpacing:"0px",
  },
  description: {
    fontSize: "13px",
    maxWidth: "700px",
    margin: "0 auto 30px",
    lineHeight: "1.6",
    color: "white",
    textAlign:"justify",
  },
  button: {
    backgroundColor: "#ffd700",
    color: "black",
    padding: "12px 25px",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "0.3s",
  },
};

export default OpportunitiesSection;
